import * as React from 'react';
import { styled } from '@mui/material/styles';
import Divider, { dividerClasses } from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import { paperClasses } from '@mui/material/Paper';
import { listClasses } from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon, { listItemIconClasses } from '@mui/material/ListItemIcon';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import MenuButton from "./options_menu_button";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {updateUser} from "../../../../store/slices/session_slice";
import {User} from "../../../../models/user";
import {clearAllTokens} from "../../../../store/credential_manager";

const MenuItem = styled(MuiMenuItem)({
    margin: '2px 0',
});

export default function OptionsMenu() {
    const location = useLocation();
    const isAccountPage = location.pathname.includes("/account");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        clearAllTokens(); // logging out
        dispatch(updateUser({} as User));
        navigate('/login');
    }

    return (
        <React.Fragment>
            <MenuButton aria-label="Open menu" onClick={handleClick} sx={{ borderColor: 'transparent' }}>
                <MoreVertRoundedIcon />
            </MenuButton>
            <Menu anchorEl={anchorEl}
                id="menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                sx={{[`& .${listClasses.root}`]: {
                        padding: '4px',
                    },
                    [`& .${paperClasses.root}`]: {
                        padding: 0,
                    },
                    [`& .${dividerClasses.root}`]: {
                        margin: '4px -4px',
                    }}}>

                {!isAccountPage &&
                    <div>
                        <MenuItem onClick={() => navigate('/account')}>My account</MenuItem>
                        <Divider />
                    </div>
                }

                <MenuItem onClick={handleLogout}
                    sx={{[`& .${listItemIconClasses.root}`]: {
                            ml: 'auto',
                            minWidth: 0,}}}>
                    <ListItemText>Logout</ListItemText>
                    <ListItemIcon>
                        <LogoutRoundedIcon fontSize="small" />
                    </ListItemIcon>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
